module.exports = __webpack_public_path__ + "images/favorites_empty_state.webp";